var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStack3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.392,7.45l-7.5-4.836L3.392,7.45l7.5,4.836,7.5-4.836Zm-7.5,5.915L4.272,9.254l-.88.86,7.5,4.836,7.5-4.836L17.5,9.235l-6.608,4.13Zm0,2.665-6.62-4.111-.88.86,7.5,4.836,7.5-4.836L17.5,11.9l-6.608,4.13Z",
    transform: "translate(-3.392 -2.614)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack3);
export default __webpack_public_path__ + "static/media/stack3.05dfc568.svg";
export { ForwardRef as ReactComponent };